<div class="screen screen--chat">

  <header class="chat__head">
    <div class="chat__head-row">
      <span class="chat__avatar<%= mode === 'concierge' ? ' chat__avatar--ai' : '' %>"><i class="icon icon--<%= mode === 'concierge' ? 'sparkles' : 'concierge-bell' %>"></i></span>
      <span class="chat__head-text">
        <span class="chat__name"><%= host.name %><% if ( mode === 'concierge' ) { %> <span class="chat__ai"><%= _lcs( 'KI' ) %></span><% } %></span>
        <span class="chat__role"><%= host.role %></span>
      </span>
    </div>
    <% if ( hasConcierge ) { %>
    <div class="chat__switch">
      <% if ( mode === 'concierge' ) { %>
      <button type="button" class="chat__switch-btn" data-chat-action="handover">
        <i class="icon icon--message-circle"></i> <%= _lcs( 'Direkt an {name} schreiben', { name: host.houseName } ) %>
      </button>
      <% } else { %>
      <button type="button" class="chat__switch-btn" data-chat-action="concierge">
        <i class="icon icon--sparkles"></i> <%= _lcs( 'Concierge fragen' ) %>
      </button>
      <% } %>
    </div>
    <% } %>
  </header>

  <div class="chat__scroll" data-id="scroll">

    <% if ( failed ) { %>
      <p class="chat__notice chat__notice--error">
        <i class="icon icon--triangle-alert"></i>
        <%= _lcs( 'Der Chat konnte nicht geladen werden. Zieh nach unten oder versuch es später noch einmal.' ) %>
      </p>
    <% } else if ( greeting ) { %>
      <div class="chat__line chat__line--concierge">
        <div class="bubble bubble--concierge">
          <span class="bubble__ai"><span class="chat__ai"><%= _lcs( 'KI' ) %></span> <%= host.name %></span>
          <span class="bubble__text"><%= greeting %></span>
        </div>
      </div>
      <% if ( anonymous ) { %>
      <p class="chat__note"><i class="icon icon--info"></i> <%= _lcs( 'Ohne Konto antwortet hier nur der Concierge. Um deinen Gastgebern direkt zu schreiben, brauchst du ein bestätigtes Konto.' ) %></p>
      <% } %>
    <% } else if ( lines.length === 0 ) { %>
      <div class="chat__intro">
        <span class="chat__intro-icon"><i class="icon icon--message-circle"></i></span>
        <h2 class="chat__intro-title"><%= _lcs( 'Schreib deinen Gastgebern' ) %></h2>
        <p class="chat__intro-text">
          <%= _lcs( 'Fragen zum Check-in, ein Tipp für heute Abend oder eine Bitte — {name} antwortet dir hier direkt.', { name: host.name } ) %>
        </p>
      </div>
    <% } %>

    <% lines.forEach( function( l ) { %>
      <% if ( l.type === 'day' ) { %>
        <div class="chat__sys"><%= l.text %></div>
      <% } else if ( l.type === 'sys' ) { %>
        <div class="chat__sys chat__sys--status"><%= l.text %></div>
      <% } else { %>
        <div class="chat__line chat__line--<%= l.from %>">
          <div class="bubble bubble--<%= l.from %>">
            <% if ( l.from === 'concierge' ) { %><span class="bubble__ai"><span class="chat__ai"><%= _lcs( 'KI' ) %></span> <%= _lcs( 'Concierge' ) %></span><% } %>
            <span class="bubble__text"><%= l.text %></span>
            <span class="bubble__meta">
              <%= l.time %>
              <% if ( l.from === 'me' && l.isRead ) { %><i class="icon icon--check bubble__read" title="<%= _lcs( 'Gelesen' ) %>"></i><% } %>
            </span>
          </div>
        </div>
        <% if ( l.links && l.links.length ) { %>
        <div class="chat__links">
          <% l.links.forEach( function( link ) { %>
          <a href="<%= link.route %>" class="chip chip--link" data-route="<%= link.route.replace( /^#/, '' ) %>"><i class="icon icon--arrow-right"></i> <%= link.label %></a>
          <% } ); %>
        </div>
        <% } %>
        <% if ( l.showOffer ) { %>
        <div class="chat__offer">
          <span class="chat__offer-text"><%= _lcs( 'Soll ich das an {name} weitergeben?', { name: host.houseName } ) %></span>
          <span class="chat__offer-actions">
            <button type="button" class="btn btn--primary btn--sm" data-chat-action="offer-yes"><%= _lcs( 'Ja, weitergeben' ) %></button>
            <button type="button" class="btn btn--ghost btn--sm" data-chat-action="offer-no" data-line="<%= l.id %>"><%= _lcs( 'Nein, danke' ) %></button>
          </span>
        </div>
        <% } %>
      <% } %>
    <% } ); %>

    <% if ( sending ) { %>
      <div class="chat__line chat__line--concierge">
        <div class="bubble bubble--concierge bubble--typing" aria-label="<%= _lcs( 'Der Concierge schreibt …' ) %>"><span></span><span></span><span></span></div>
      </div>
    <% } %>

  </div>

  <% if ( replies.length > 0 ) { %>
  <div class="chat__replies" data-id="replies">
    <% replies.forEach( function( r ) { var t = r.translate ? _lcs( r.text ) : r.text; %>
      <button class="chip chip--reply" type="button" data-reply="<%= t %>"><%= t %></button>
    <% } ); %>
  </div>
  <% } %>

  <form class="composer" data-id="composer">
    <div class="composer__field">
      <input class="composer__input" type="text" placeholder="<%= mode === 'concierge' ? _lcs( 'Frag den Concierge …' ) : _lcs( 'Nachricht schreiben …' ) %>"
             autocomplete="off" maxlength="<%= anonymous ? 1000 : 4000 %>" data-id="input" />
    </div>
    <button class="composer__send" type="submit" data-id="send" aria-label="<%= _lcs( 'Senden' ) %>">
      <i class="icon icon--send-horizontal"></i>
    </button>
  </form>

</div>
